import { Licenses, RootActions, RootGetters, RootMutations, RootState } from "@medapro-types/common/rootstate";
import { computed } from "vue";
import { Store } from "vuex";
import { useActions, useGetters, useMutations, useState } from "vuex-composition-helpers";

export const useSaveState = () => {
  const { saveStateMeta } = useState<RootState>(["saveStateMeta"]);
  const { saveState } = useGetters<RootGetters>(["saveState"]);
  const { getSavePromiseResultAndResolve } = useActions<RootActions>(["getSavePromiseResultAndResolve"]);
  const { "add-saving-promise": addSavingPromise, "set-unsaved-state": setUnsavedState } = useMutations<RootMutations>([
    "add-saving-promise",
    "set-unsaved-state"
  ]);

  return { saveState, saveStateMeta, addSavingPromise, setUnsavedState, getSavePromiseResultAndResolve };
};

export const useLicenses = (store: Store<RootState> | null = null) => {
  const { licenses } = store ? useState<RootState>(store, ["licenses"]) : useState<RootState>(["licenses"]);

  const checkForLicensed = (licenseName: keyof Licenses) => {
    return licenses.value?.[licenseName] === "Licensed";
  };

  return { licenses, checkForLicensed };
};

export function useAuth() {
  const { auth } = useState<RootState>(["auth"]);
  return { auth };
}
export function useUser() {
  const { user } = useState<RootState>(["user"]);
  const { UpdateIdentity } = useMutations<RootMutations>(["UpdateIdentity"]);
  return { user, UpdateIdentity };
}

export function useUserSettings(store: Store<RootState> | null = null, action: Store<RootActions> | null = null) {
  const { userSettings } = store ? useState<RootState>(store, ["userSettings"]) : useState<RootState>(["userSettings"]);
  const { saveUserSettings } = action ? useActions<RootActions>(action, ["saveUserSettings"]) : useActions<RootActions>(["saveUserSettings"]);
  const currentLocale = computed(() => userSettings.value.CurrentLocale);

  return { userSettings, currentLocale, saveUserSettings };
}

export function useGlobalParameters() {
  const { globalParameters } = useState<RootState>(["globalParameters"]);
  return { globalParameters };
}

export function useMetadata() {
  const { meta: metadata } = useState<RootState>(["meta"]);
  return { metadata };
}
